import { Button, Colors, IcFolderOutlined, IcUpload } from 'basic-ui-lib';
import { FooterMobile } from 'layouts/widgets/BottomMobile';
import HeaderMobile from 'layouts/widgets/HeaderMobile';
import styled from 'styled-components';
import HeaderSearch from './HeaderSearch';
import { useMediaExplorer } from 'modules/media/services/hooks/useMediaExplorer';
import useViewMode from 'modules/media/services/hooks/useViewMode';
import useGetManageLibrary from 'modules/media/services/hooks/useGetManageLibrary';
import MediaManagerGridModeMobile from './MediaManagerGridModeMobile';
import MediaManagerListModeMobile from './MediaManagerListModeMobile';
import CreateFolderModal, { CreateFolderModalRef } from '../LibraryList/CreateFolderModal';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const MediaMobile = () => {
  const [data, mutate] = useGetManageLibrary(true);
  const { mode: viewMode, setViewMode } = useViewMode();
  const { items, openFolder, currentPath, pathStack } = useMediaExplorer(data, mutate);
  const createFolderModalRef = useRef<CreateFolderModalRef>(null);
  const navigate = useNavigate();
  const current = pathStack[pathStack.length - 1];
  
  const handleCreateNewFolder = () => {
    createFolderModalRef.current?.open(currentPath);
  };
  
  const handleUploadImageOrVideo = () => {
    navigate('/media-upload', {
      state: { currentPath: currentPath },
    });
  };

  const onBack = () => {
    if (currentPath === ' ') {
      navigate('/setting');
      return;
    }

    navigate(-1);
  };

  return (
    <Container>
      <HeaderMobile title={current?.label || 'Media Library'} onBack={onBack} />
      <Content>
        <HeaderSearch
          viewMode={viewMode}
          onChangeViewMode={setViewMode}
          //   path={pathStack}
          //   onBack={onBack}
          currentPath={currentPath}
        />
        {viewMode === 'list' ? (
          <MediaManagerListModeMobile items={items} onOpenFolder={openFolder} currentPath={currentPath} onSuccess={mutate} />
        ) : (
          <MediaManagerGridModeMobile items={items} onOpenFolder={openFolder} currentPath={currentPath} onSuccess={mutate} />
        )}
      </Content>
      <FooterMobile>
        <Button
          lg
          type_primary
          prefix={<IcFolderOutlined width={20} height={20} fill={Colors.neutral.bg[1]} />}
          onClick={handleCreateNewFolder}
        >
          New Folder
        </Button>
        <Button lg type_second prefix={<IcUpload width={20} height={20} fill={Colors.neutral.bg[1]} />} onClick={handleUploadImageOrVideo}>
          Upload
        </Button>
      </FooterMobile>
      <CreateFolderModal ref={createFolderModalRef} onSuccess={mutate} />
      {/* <MenuActionMobile listMenu={listMenu} open={open} onClose={() => setOpen(false)} onClickMenu={handleMenuClick} /> */}
    </Container>
  );
};

export default MediaMobile;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  
  .type_primary,
  .type_second {
    padding: 0px 8px;
  }
`;

const Content = styled.div`
  flex: 1;
  padding: 24px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
`;
